import { gql } from '@apollo/client'

export default gql(`
mutation batchDeleteStreamLevel($deleteInput: [DeleteStreamLevelInput]!){
    batchDeleteStreamLevel(input: $deleteInput){
      id
    }
  }`
)
